import firebase from "firebase";
import axios from "axios";

import moment from "moment";
moment.locale("es");

import countries from "./countries.json";

const BASE_URL = "https://us-central1-escuelapp-5f754.cloudfunctions.net/";

const BASE_URL_V2_TESTING = "https://localhost:7148/api/";
const BASE_URL_V2_PRODUCTION =
  "https://escuelapp-api-v2.azurewebsites.net/api/";

const TESTING = false;

const canaryZIP = [
  35001, 35002, 35003, 35004, 35005, 35006, 35007, 35008, 35009, 35010, 35011,
  35012, 35013, 35014, 35015, 35016, 35017, 35018, 35019, 35100, 35106, 35107,
  35108, 35109, 35110, 35118, 35119, 35120, 35128, 35129, 35130, 35138, 35139,
  35140, 35149, 35200, 35210, 35211, 35212, 35213, 35214, 35215, 35216, 35217,
  35218, 35219, 35220, 35229, 35230, 35240, 35250, 35259, 35260, 35269, 35270,
  35280, 35290, 35299, 35300, 35307, 35308, 35309, 35310, 35319, 35320, 35328,
  35329, 35330, 35333, 35338, 35339, 35340, 35349, 35350, 35360, 35368, 35369,
  35400, 35411, 35412, 35413, 35414, 35415, 35420, 35421, 35422, 35423, 35430,
  35431, 35432, 35450, 35457, 35458, 35459, 35460, 35468, 35469, 35470, 35478,
  35479, 35480, 35488, 35489, 35500, 35507, 35508, 35509, 35510, 35520, 35530,
  35539, 35540, 35541, 35542, 35543, 35544, 35550, 35558, 35559, 35560, 35561,
  35570, 35571, 35572, 35580, 35600, 35610, 35611, 35612, 35613, 35620, 35625,
  35626, 35627, 35628, 35629, 35630, 35637, 35638, 35639, 35640, 35649, 35650,
  35660, 38001, 38002, 38003, 38004, 38005, 38006, 38007, 38008, 38009, 38010,
  38107, 38108, 38109, 38110, 38111, 38120, 38129, 38130, 38139, 38140, 38150,
  38160, 38170, 38180, 38190, 38201, 38202, 38203, 38204, 38205, 38206, 38207,
  38208, 38240, 38250, 38260, 38270, 38280, 38290, 38291, 38292, 38293, 38294,
  38296, 38297, 38300, 38310, 38311, 38312, 38313, 38314, 38315, 38320, 38329,
  38330, 38340, 38350, 38355, 38356, 38357, 38358, 38359, 38360, 38370, 38379,
  38380, 38389, 38390, 38398, 38399, 38400, 38410, 38412, 38413, 38414, 38415,
  38416, 38417, 38418, 38419, 38420, 38428, 38429, 38430, 38434, 38435, 38438,
  38439, 38440, 38441, 38449, 38450, 38458, 38459, 38460, 38470, 38479, 38480,
  38489, 38500, 38508, 38509, 38510, 38520, 38530, 38540, 38550, 38560, 38570,
  38579, 38580, 38588, 38589, 38590, 38591, 38592, 38593, 38594, 38595, 38600,
  38610, 38611, 38612, 38613, 38614, 38615, 38616, 38617, 38618, 38619, 38620,
  38626, 38627, 38628, 38629, 38630, 38631, 38632, 38639, 38640, 38649, 38650,
  38652, 38660, 38670, 38677, 38678, 38679, 38680, 38683, 38684, 38685, 38686,
  38687, 38688, 38689, 38690, 38700, 38710, 38711, 38712, 38713, 38714, 38715,
  38720, 38726, 38727, 38728, 38729, 38730, 38738, 38739, 38740, 38749, 38750,
  38758, 38759, 38760, 38767, 38768, 38769, 38770, 38779, 38780, 38787, 38788,
  38789, 38800, 38801, 38810, 38811, 38812, 38813, 38820, 38829, 38830, 38840,
  38849, 38850, 38852, 38860, 38869, 38870, 38879, 38890, 38891, 38892, 38900,
  38910, 38911, 38912, 38913, 38914, 38915, 38916, 38917, 51001, 51002, 51003,
  51004, 51005, 52004, 52001, 52002, 52003, 52005, 52006,
];

const testKey = "pk_test_AWIi7aMrX3qbdQpr57wsueei00a5vIzcXR";
const productionKey = "pk_live_JqMlcV5hos6at5MY5SsvfAM200552ZQFUt";

const testingRemaxMx = false;
const testingAgora = false;
const testingMsl = false;
const testingInmovilla = false;

export default class GeneralApi {
  constructor() {}

  getWelcomeMessage() {
    var customer = window.location.hostname;
    if (customer.includes("agora") || testingAgora) {
      return (
        "<p class='special-p'>La venta no es cuestión de suerte, ni de magia, <b>es cuestión de procesos</b>. Procesos que encontrarás en esta escuela junto a las  estrategias y argumentos con los que cientos de profesionales inmobiliarios han llegado a <b>resultados de alto rendimiento.</b></p>" +
        "                  <p class='special-p'>El concepto de esta escuela es el de hacer un <b>Netflix formativo</b> donde en lugar de pagar por cada curso, con una pequeña suscripción mensual tienes acceso a todos los contenidos y en todo momento. <b>Tan sólo 9,90€</b> al mes en pago anual o 14,86€ en pago mensual, más iva si estás en la comunidad europea.</p>" +
        "                  <p class='special-p'>Si conoces a algún alumno de la escuela, dile que te facilite su enlace de <b>\"Plan Amigo\"</b>. Por venir de su parte disfrutarás de <b>10 DIAS GRATIS</b> para ver todos los vídeos que quieras y comprobar si la escuela te aporta valor. Y una vez suscrito, invita a tu equipo, colegas o amigos de tu MLS y <b>recibirás 30 DÍAS GRATIS por cada uno de ellos.</b></p>" +
        "                  <p class='special-p'>¿Que te parece? ¿Comenzamos? Pulsa " +
        "                  <a" +
        '                    href="./#/app/inicio/register"' +
        '                    style={{ color: "blue" }}' +
        "                  >" +
        "                    aquí para crear tu cuenta" +
        "                  </a></p>" +
        "                  <p class='special-p'>José Luis Jimeno" +
        "                  <br/>" +
        "                  Salud y Ventas</p>" +
        "                  <br/>" +
        "                  #TodoPorLasVentas"
      );
    } else if (customer.includes("remaxmx") || testingRemaxMx) {
      return (
        "<p class='special-p'>La venta no es cuestión de suerte, ni de magia, <b>es cuestión de procesos</b>. Procesos que encontrarás en esta escuela junto a las  estrategias y argumentos con los que cientos de profesionales inmobiliarios han llegado a <b>resultados de alto rendimiento.</b></p>" +
        "                  <p class='special-p'>El concepto de esta escuela es el de hacer un <b>Netflix formativo</b> donde en lugar de pagar por cada curso, con una pequeña suscripción mensual tienes acceso a todos los contenidos y en todo momento. <b>Tan sólo 9,90€</b> al mes en pago anual o 14,86€ en pago mensual, más iva si estás en la comunidad europea.</p>" +
        "                  <p class='special-p'>Si conoces a algún alumno de la escuela, dile que te facilite su enlace de <b>\"Plan Amigo\"</b>. Por venir de su parte disfrutarás de <b>10 DIAS GRATIS</b> para ver todos los vídeos que quieras y comprobar si la escuela te aporta valor. Y una vez suscrito, invita a tu equipo, colegas o amigos de tu MLS y <b>recibirás 30 DÍAS GRATIS por cada uno de ellos.</b></p>" +
        "                  <p class='special-p'>¿Que te parece? ¿Comenzamos? Pulsa " +
        "                  <a" +
        '                    href="./#/app/inicio/register"' +
        '                    style={{ color: "blue" }}' +
        "                  >" +
        "                    aquí para crear tu cuenta" +
        "                  </a></p>" +
        "                  <p class='special-p'>José Luis Jimeno" +
        "                  <br/>" +
        "                  Salud y Ventas</p>" +
        "                  <br/>" +
        "                  #TodoPorLasVentas"
      );
    } else if (customer.includes("mls") || testingMsl) {
      return (
        "<p class='special-p'>La venta no es cuestión de suerte, ni de magia, <b>es cuestión de procesos</b>. Procesos que encontrarás en esta escuela junto a las  estrategias y argumentos con los que cientos de profesionales inmobiliarios han llegado a <b>resultados de alto rendimiento.</b></p>" +
        "                  <p class='special-p'>El concepto de esta escuela es el de hacer un <b>Netflix formativo</b> donde en lugar de pagar por cada curso, con una pequeña suscripción mensual tienes acceso a todos los contenidos y en todo momento. <b>Tan sólo 9,90€</b> al mes en pago anual o 14,86€ en pago mensual, más iva si estás en la comunidad europea.</p>" +
        "                  <p class='special-p'>Si conoces a algún alumno de la escuela, dile que te facilite su enlace de <b>\"Plan Amigo\"</b>. Por venir de su parte disfrutarás de <b>10 DIAS GRATIS</b> para ver todos los vídeos que quieras y comprobar si la escuela te aporta valor. Y una vez suscrito, invita a tu equipo, colegas o amigos de tu MLS y <b>recibirás 30 DÍAS GRATIS por cada uno de ellos.</b></p>" +
        "                  <p class='special-p'>¿Que te parece? ¿Comenzamos? Pulsa " +
        "                  <a" +
        '                    href="./#/app/inicio/register"' +
        '                    style={{ color: "blue" }}' +
        "                  >" +
        "                    aquí para crear tu cuenta" +
        "                  </a></p>" +
        "                  <p class='special-p'>José Luis Jimeno" +
        "                  <br/>" +
        "                  Salud y Ventas</p>" +
        "                  <br/>" +
        "                  #TodoPorLasVentas"
      );
    } else if (customer.includes("inmovilla") || testingInmovilla) {
      return (
        "<p class='special-p'>La venta no es cuestión de suerte, ni de magia, <b>es cuestión de procesos</b>. Procesos que encontrarás en esta escuela junto a las  estrategias y argumentos con los que cientos de profesionales inmobiliarios han llegado a <b>resultados de alto rendimiento.</b></p>" +
        "                  <p class='special-p'>El concepto de esta escuela es el de hacer un <b>Netflix formativo</b> donde en lugar de pagar por cada curso, con una pequeña suscripción mensual tienes acceso a todos los contenidos y en todo momento. <b>Tan sólo 9,90€</b> al mes en pago anual o 14,86€ en pago mensual, más iva si estás en la comunidad europea.</p>" +
        "                  <p class='special-p'>Si conoces a algún alumno de la escuela, dile que te facilite su enlace de <b>\"Plan Amigo\"</b>. Por venir de su parte disfrutarás de <b>10 DIAS GRATIS</b> para ver todos los vídeos que quieras y comprobar si la escuela te aporta valor. Y una vez suscrito, invita a tu equipo, colegas o amigos de tu MLS y <b>recibirás 30 DÍAS GRATIS por cada uno de ellos.</b></p>" +
        "                  <p class='special-p'>¿Que te parece? ¿Comenzamos? Pulsa " +
        "                  <a" +
        '                    href="./#/app/inicio/register"' +
        '                    style={{ color: "blue" }}' +
        "                  >" +
        "                    aquí para crear tu cuenta" +
        "                  </a></p>" +
        "                  <p class='special-p'>José Luis Jimeno" +
        "                  <br/>" +
        "                  Salud y Ventas</p>" +
        "                  <br/>" +
        "                  #TodoPorLasVentas"
      );
    } else {
      return (
        "<p class='special-p'>La venta no es cuestión de suerte, ni de magia, <b>es cuestión de procesos</b>. Procesos que encontrarás en esta escuela junto a las  estrategias y argumentos con los que cientos de profesionales inmobiliarios han llegado a <b>resultados de alto rendimiento.</b></p>" +
        "                  <p class='special-p'>El concepto de esta escuela es el de hacer un <b>Netflix formativo</b> donde en lugar de pagar por cada curso, con una pequeña suscripción mensual tienes acceso a todos los contenidos y en todo momento. <b>Tan sólo 9,90€</b> al mes en pago anual o 14,86€ en pago mensual, más iva si estás en la comunidad europea.</p>" +
        "                  <p class='special-p'>Si conoces a algún alumno de la escuela, dile que te facilite su enlace de <b>\"Plan Amigo\"</b>. Por venir de su parte disfrutarás de <b>10 DIAS GRATIS</b> para ver todos los vídeos que quieras y comprobar si la escuela te aporta valor. Y una vez suscrito, invita a tu equipo, colegas o amigos de tu MLS y <b>recibirás 30 DÍAS GRATIS por cada uno de ellos.</b></p>" +
        "                  <p class='special-p'>¿Que te parece? ¿Comenzamos? Pulsa " +
        "                  <a" +
        '                    href="./#/app/inicio/register"' +
        '                    style={{ color: "blue" }}' +
        "                  >" +
        "                    aquí para crear tu cuenta" +
        "                  </a></p>" +
        "                  <p class='special-p'>José Luis Jimeno" +
        "                  <br/>" +
        "                  Salud y Ventas</p>" +
        "                  <br/>" +
        "                  #TodoPorLasVentas"
      );
    }
  }

  getApiUrl() {
    return TESTING ? BASE_URL_V2_TESTING : BASE_URL_V2_PRODUCTION;
  }

  isSpain() {
    return true;
  }

  isAgora() {
    var customer = window.location.hostname;
    if (customer.includes("agora") || testingAgora) {
      return true;
    }
    return false;
  }

  isRemax() {
    var customer = window.location.hostname;
    if (customer.includes("remaxmx") || testingRemaxMx) {
      return true;
    }
    return false;
  }

  isInmovilla() {
    var customer = window.location.hostname;
    if (customer.includes("inmovilla") || testingInmovilla) {
      return true;
    }
    return false;
  }

  getDefaultRegalaFormacion() {
    var customer = window.location.hostname;

    if (customer.includes("remaxmx") || testingRemaxMx) {
      return "price_1IOiwcFaAT8NSpmETwOGRm1W";
    } else if (customer.includes("mls") || testingMsl) {
      return "price_1ITkgdFaAT8NSpmEBuMMhCRc";
    } else if (customer.includes("agora") || testingAgora) {
      return "price_1LdFgRFaAT8NSpmEdOKB8c7V";
    } else {
      return "price_1I43KWFaAT8NSpmEUxca36Qd";
    }
  }

  getPriceRegalaFormacionIDA() {
    var customer = window.location.hostname;

    if (customer.includes("remaxmx") || testingRemaxMx) {
      return "price_1IOiwcFaAT8NSpmEhJivQyBD";
    } else if (customer.includes("mls") || testingMsl) {
      return "price_1ITkgdFaAT8NSpmEkNeSlWc1";
    } else if (customer.includes("agora") || testingAgora) {
      return "price_1LdFgRFaAT8NSpmEdOKB8c7V";
    } else {
      return TESTING
        ? "price_1I4OfXFaAT8NSpmEt8ZvW5iY"
        : "price_1I43KWFaAT8NSpmEUxca36Qd";
    }
  }

  getPriceRegalaFormacionIDB() {
    var customer = window.location.hostname;

    if (customer.includes("remaxmx") || testingRemaxMx) {
      return "price_1IOiwcFaAT8NSpmEGa8ZqkPB";
    } else if (customer.includes("mls") || testingMsl) {
      return "price_1ITkgdFaAT8NSpmEFdFiVQzk";
    } else if (customer.includes("agora") || testingAgora) {
      return "price_1JaHITFaAT8NSpmEbxG6mSSX";
    } else {
      return "price_1I43KWFaAT8NSpmESS8eTfN4";
    }
  }

  getPriceRegalaFormacionIDC() {
    var customer = window.location.hostname;

    if (customer.includes("remaxmx") || testingRemaxMx) {
      return "price_1IOiwcFaAT8NSpmETwOGRm1W";
    } else if (customer.includes("mls") || testingMsl) {
      return "price_1ITkgdFaAT8NSpmEBuMMhCRc";
    } else if (customer.includes("agora") || testingAgora) {
      return "price_1JaHITFaAT8NSpmEZmfylu1q";
    } else {
      return "price_1I43KXFaAT8NSpmEkxd1ZeK0";
    }
  }

  // 00:01 del 8 de septiembre en España peninsular
  isUxeFreeCutoffPassed() {
    return new Date() >= new Date(Date.UTC(2026, 8, 7, 22, 1));
  }

  getDefaultSubscription() {
    if (this.isRemax()) {
      return "price_1PdzdTFaAT8NSpmEmYgdY8oJ";
    }

    if (this.isInmovilla()) {
      return "price_1Mcnx9FaAT8NSpmEj8qm2xWm";
    }

    return TESTING
      ? "price_1McokQFaAT8NSpmEl16gGU20"
      : "price_1K1E8jFaAT8NSpmEOLx0knmy";
  }

  getPriceIDA() {
    if (this.isAgora()) {
      return "price_1LdFbcFaAT8NSpmE9p6owRtG";
    }

    if (this.isRemax()) {
      return "price_1PdzdTFaAT8NSpmEmYgdY8oJ";
    }

    if (this.isInmovilla()) {
      if (testingInmovilla) {
        return "price_1McokQFaAT8NSpmEl16gGU20";
      } else {
        return "price_1Mcnx9FaAT8NSpmEj8qm2xWm";
      }
    }

    return TESTING
      ? "price_1HcPrXFaAT8NSpmEBptA62tJ"
      : "price_1K1E8jFaAT8NSpmEOLx0knmy";
  }

  getPriceIDB() {
    if (this.isInmovilla()) {
      if (testingInmovilla) {
        return "price_1Mcnx9FaAT8NSpmE8V88L4D7";
      } else {
        return "price_1Mcnx9FaAT8NSpmE8V88L4D7";
      }
    }

    return "price_1K1E8jFaAT8NSpmES3bgBjyk";
  }

  getPriceIDC() {
    return "price_1K1E8jFaAT8NSpmES3bgBjyk";
  }

  getPriceIDD() {
    return "price_1K1yQiFaAT8NSpmEgvHxo9nw";
  }

  getImage(imageNeeded) {
    var customer = window.location.hostname;

    if (customer.includes("remaxmx") || testingRemaxMx) {
      return `../assets/images/remaxmx/${imageNeeded}`;
    } else if (customer.includes("mls") || testingMsl) {
      return `../assets/images/mls/${imageNeeded}`;
    } else if (customer.includes("agora") || testingAgora) {
      return `../assets/images/agora/${imageNeeded}`;
    } else if (customer.includes("inmovilla") || testingInmovilla) {
      return `../assets/images/inmovilla/${imageNeeded}`;
    } else {
      return `../assets/images/${imageNeeded}`;
    }
  }

  getMenuStyle() {
    var customer = window.location.hostname;
    //"prepend-icon"
    if (customer.includes("remaxmx") || testingRemaxMx) {
      return "prepend-icon-remax";
    } else if (customer.includes("mls") || testingMsl) {
      return "prepend-icon-mls";
    } else if (customer.includes("agora") || testingAgora) {
      return "prepend-icon-agora";
    } else if (customer.includes("inmovilla") || testingInmovilla) {
      return "prepend-icon-inmovilla";
    } else {
      return "prepend-icon";
    }
  }

  getButtonsStyle() {
    var customer = window.location.hostname;
    //"prepend-icon"
    if (customer.includes("remaxmx") || testingRemaxMx) {
      return "login-form-button";
    } else if (customer.includes("mls") || testingMsl) {
      return "login-form-button-mls";
    } else if (customer.includes("agora") || testingAgora) {
      return "login-form-button-agora";
    } else if (customer.includes("inmovilla") || testingInmovilla) {
      return "login-form-button-inmovilla";
    } else {
      return "login-form-button";
    }
  }

  getIconStyle() {
    var customer = window.location.hostname;

    if (customer.includes("remaxmx") || testingRemaxMx) {
      return `bgiconremaxmx`;
    } else if (customer.includes("mls") || testingMsl) {
      return `bgiconmls`;
    } else if (customer.includes("agora") || testingAgora) {
      return `bgiconagora`;
    } else if (customer.includes("inmovilla") || testingInmovilla) {
      return `bgiconinmovilla`;
    } else {
      return `bgicon`;
    }
  }

  getButtonColor() {
    var customer = window.location.hostname;

    if (customer.includes("remaxmx") || testingRemaxMx) {
      return "#c51828";
    } else if (customer.includes("mls") || testingMsl) {
      return "#000";
    } else if (customer.includes("agora") || testingAgora) {
      return "#0b693f";
    } else if (customer.includes("inmovilla") || testingInmovilla) {
      return "#003562";
    } else {
      return "#003562";
    }
  }

  getBackgroundColor() {
    var customer = window.location.hostname;

    if (customer.includes("remaxmx") || testingRemaxMx) {
      return "#c51828";
    } else if (customer.includes("mls") || testingMsl) {
      return "#fdfdfd";
    } else if (customer.includes("agora") || testingAgora) {
      return "#7d082f";
    } else if (customer.includes("inmovilla") || testingInmovilla) {
      return "#4a8ec4";
    } else {
      return "#003562";
    }
  }

  testing() {
    return TESTING;
  }

  testKey() {
    return testKey;
  }

  productionKey() {
    return productionKey;
  }

  canaryZIP() {
    return canaryZIP;
  }

  uploadImagen(files) {
    return new Promise((resolve, reject) => {
      let selectedFile = files[0];
      var storageRef = firebase.storage().ref();

      const uploadTask = storageRef
        .child(`profilepics/${selectedFile.name}`)
        .put(selectedFile); //create a child directory called images, and place the file inside this directory

      uploadTask.on(
        "state_changed",
        function (snapshot) {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          //console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              //console.log("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              //console.log("Upload is running");
              break;
          }
        },
        function (error) {
          // Handle unsuccessful uploads
          //console.log(error);
          reject(false);
        },
        function () {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            //console.log("File available at", downloadURL);
            resolve(downloadURL);
          });
        },
      );
    });
  }

  getCountries() {
    return countries;
  }

  getPrices() {
    if (this.isAgora()) {
      return {
        priceA: "95,59€",
        priceB: "994,62€",
        priceC: "179,81€",
        priceD: "1.437,48",
        priceASINIVA: "79€",
        priceBSINIVA: "122.81€",
        priceCSINIVA: "148,6€",
        priceDSINIVA: "1188€",

        priceAMONTH: "99€",
        priceBMONTH: "148,6€",
        priceCMONTH: "148,6€",
        priceDMONTH: "99€",
        testudoSINIVA: "1980€",
        testudoCONIVA: "2395,8€",
      };
    }

    if (this.isRemax()) {
      return {
        priceA: "79€",
        priceB: "994,62€",
        priceC: "179,81€",
        priceD: "1.437,48",
        priceASINIVA: "79€",
        priceBSINIVA: "122.81€",
        priceCSINIVA: "148,6€",
        priceDSINIVA: "1188€",

        priceAMONTH: "79€",
        priceBMONTH: "148,6€",
        priceCMONTH: "148,6€",
        priceDMONTH: "99€",
        testudoSINIVA: "1980€",
        testudoCONIVA: "2395,8€",
      };
    }

    if (this.isInmovilla()) {
      return {
        priceA: "95,59€",
        priceB: "143,99",
        priceC: "",
        priceD: "",
        priceASINIVA: "79€",
        priceBSINIVA: "119,00€",
        priceCSINIVA: "",
        priceDSINIVA: "",

        priceAMONTH: "95,59€",
        priceBMONTH: "143,99€",
        priceCMONTH: "",
        priceDMONTH: "",
        testudoSINIVA: "",
        testudoCONIVA: "",
      };
    }

    return {
      priceA: "119,79€",
      priceB: "994,62€",
      priceC: "179,81€",
      priceD: "1.437,48",
      priceASINIVA: "99€",
      priceBSINIVA: "148,6€",
      priceCSINIVA: "148,6€",
      priceDSINIVA: "1188€",

      priceAMONTH: "99€",
      priceBMONTH: "68,50€",
      priceCMONTH: "148,6€",
      priceDMONTH: "99€",
      testudoSINIVA: "1980€",
      testudoCONIVA: "2395,8€",
    };
  }

  getUserInfo(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.getApiUrl()}accounts/getbyuid/${encodeURIComponent(id)}`, { timeout: 15000 })
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => {
          resolve(null);
        });
    });
  }

  getUserInfoByEmail(email, uid) {
    const validEmail =
      typeof email === "string" &&
      email !== "null" &&
      email !== "undefined" &&
      email.trim() !== "";

    if (validEmail) {
      const cleanedEmail = email.trim();

      return new Promise((resolve) => {
        axios
          .get(`${this.getApiUrl()}accounts/getbyemail/${encodeURIComponent(cleanedEmail)}`, { timeout: 15000 })
          .then((result) => {
            if (result.data) {
              resolve(result.data);
            } else if (uid) {
              this.getUserInfo(uid).then(resolve);
            } else {
              resolve(null);
            }
          })
          .catch(() => {
            if (uid) {
              this.getUserInfo(uid).then(resolve);
            } else {
              resolve(null);
            }
          });
      });
    }

    if (uid) {
      return this.getUserInfo(uid);
    }

    return Promise.resolve(null);
  }

  checkExistingEmail(email) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.getApiUrl()}accounts/checkexistingemail/${email}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => {
          //console.log(err);
          resolve(false);
        });
    });
  }

  getUserInfoByRowId(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.getApiUrl()}accounts/getbyuid/${encodeURIComponent(id)}`, { timeout: 15000 })
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => {
          //console.log(err);
          resolve(null);
        });
    });
  }

  addTab(userId, deviceId) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${this.getApiUrl()}accounts/addtab/${userId}/${deviceId}`)
        .then((result) => {
          //console.log("ADD TAB PUEDE CONTINUAR?", result.data);
          resolve(result.data);
        })
        .catch((err) => {
          //console.log(err);
          resolve(false);
        });
    });
  }

  removeTab(userId, deviceId) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${this.getApiUrl()}accounts/removetab/${userId}/${deviceId}`)
        .then((result) => {
          //console.log("REMOVE TAB PUEDE CONTINUAR?", result.data);
          resolve(result.data);
        })
        .catch((err) => {
          //console.log(err);
          resolve(false);
        });
    });
  }

  getTabs(userId) {
    if (!userId) return new Promise((resolve, reject) => resolve([]));

    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref("tabsv2/" + userId)
        .once("value")
        .then((snapshot) => {
          var tabs = Object.keys(snapshot.val()).map((k) => snapshot.val()[k]);

          console.log(tabs);
          resolve(tabs);
        })
        .catch((error) => {
          console.log(error);
          resolve(new Array());
        });
    });
  }

  /*removeTab(userId, deviceId) {
    firebase
      .database()
      .ref("tabsv2/" + userId)
      .child(deviceId)
      .remove()
      .then((snapshot) => {
        console.log("SE VA A BORRAR TAB");
      });
  }*/

  updateLastTab(userId, deviceId) {
    console.log("entra en update tabs");

    var postListRef = firebase.database().ref("tabsv2/" + userId);
    var newPostRef = postListRef.push();
    newPostRef.set(deviceId);

    /*firebase
      .database()
      .ref("tabs/" + userId)
      .set({
        lastDevice: deviceId,
      });*/
  }

  getMenu() {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref("/menu")
        .once("value")
        .then(function (snapshot) {
          resolve(snapshot);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  updateStripeId(userId, stripeId) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${this.getApiUrl()}accounts/updatestripecode/${userId}/${stripeId}`,
        )
        .then((result) => {
          resolve(true);
        })
        .catch((err) => {
          //console.log(err);
          resolve(false);
        });
    });
  }

  getTexts() {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref("/texts")
        .once("value")
        .then(function (snapshot) {
          resolve(snapshot);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getPage(route) {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref("/crm")
        .orderByChild("url")
        .equalTo(route)
        .once("value")
        .then(function (snapshot) {
          resolve(snapshot);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getPlanAmigos(id) {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref("/plan-amigo")
        .orderByChild("friendId")
        .equalTo(id)
        .once("value")
        .then(function (snapshot) {
          resolve(snapshot.val());
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  updateVip(email) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${this.getApiUrl()}accounts/changevipstatus/${email}/true`)
        .then((result) => {
          resolve(true);
        })
        .catch((err) => {
          //console.log(err);
          resolve(false);
        });
    });
  }

  updateStockCode(code, userData, sessionId) {
    return new Promise((resolve, reject) => {
      try {
        firebase
          .database()
          .ref("/codigos/" + code._id)
          .once("value")
          .then((snapshot) => {
            snapshot.ref
              .update({
                stock: parseInt(code.stock) - 1,
              })
              .then((result) => {
                var postListRef = firebase.database().ref("/historial-codigos");
                var newPostRef = postListRef.push();

                var item = {};

                item._id = newPostRef.getKey();

                item.codigo = code.codigo;
                item.descripcion = code.descripcion;
                item.duracion = code.duracion;
                item.email = userData.email;
                item.name = userData.name;
                item.date = new moment().format("LLLL");
                item.sessionId = sessionId;

                newPostRef
                  .set(item)
                  .then((data) => {
                    return resolve(true);
                  })
                  .catch((err) => {
                    reject(err);
                  });
              })
              .catch((err) => reject(false));
          });
      } catch (error) {
        alert(error);
      }
    });
  }

  updatePlanAmigo(id) {
    return new Promise((resolve, reject) => {
      try {
        firebase
          .database()
          .ref("/plan-amigo/" + id)
          .once("value")
          .then((snapshot) => {
            snapshot.ref
              .update({ paid: true })
              .then((result) => {
                return resolve(true);
              })
              .catch((err) => reject(false));
          });
      } catch (error) {
        alert(error);
      }
    });
  }

  createPlanAmigoRegister(friendId, user, session, name) {
    console.log("Plan amigo", friendId, user, session, name);

    return new Promise((resolve, reject) => {
      var postListRef = firebase.database().ref("/plan-amigo");
      var newPostRef = postListRef.push();

      var item = {};

      item._id = newPostRef.getKey();

      item.friendId = friendId;
      item.user = user;
      item.sessionId = session.id;
      item.customer = session.customer;
      item.date = new moment().format("LLLL");
      item.paid = false;
      item.name = name || "";

      newPostRef
        .set(item)
        .then((data) => {
          resolve(true);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  checkExist(email) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.getApiUrl()}accounts/checkexistingemail/${email}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => {
          //console.log(err);
          resolve(false);
        });
    });
  }

  checkCodigoUsado(username) {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref("/historial-codigos")
        .orderByChild("email")
        .equalTo(username)
        .once("value")
        .then((snapshot) => {
          resolve(snapshot.val());
        })
        .catch(resolve(null));
    });
  }

  checkExistPlanAmigo(username) {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref("/plan-amigo")
        .orderByChild("user")
        .equalTo(username)
        .once("value")
        .then((snapshot) => {
          //console.log("YA TIENE");
          resolve(snapshot.val());
        });
    });
  }

  checkCode(code) {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref("/codigos")
        .orderByChild("codigo")
        .equalTo(code)
        .once("value")
        .then((snapshot) => {
          if (!snapshot.val()) {
            return resolve(null);
          }
          var result = Object.keys(snapshot.val()).map(
            (k) => snapshot.val()[k],
          );
          resolve(result);
        });
    });
  }

  updateAccount(user) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${BASE_URL}updateUser`, { user }, { crossDomain: true })
        .then((res) => {
          resolve(true);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  createAccount(user) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${this.getApiUrl()}accounts/createaccount`, user, {
          crossDomain: true,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(null);
        });
    });
  }

  updateFacturacionUser(user) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${BASE_URL}updateFacturacionUser`,
          { user },
          { crossDomain: true },
        )
        .then((res) => {
          resolve(true);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  updateAllDataUser(user) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${BASE_URL}updateAllDataUser`, { user }, { crossDomain: true })
        .then((res) => {
          resolve(true);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async checkIsSubscribed(email) {
    if (!email) return false;
    try {
      const result = await axios.get(`${this.getApiUrl()}stripe/issubscribed/${encodeURIComponent(email)}`, { timeout: 15000 });
      return result.data;
    } catch (error) {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./app/generalApi.js